import React from 'react'

const Link = ({icon, title, link, isActive}) => {
  return (
        <div className="breadcrumb-item">
            { icon && <i className={`breadcrumb-icon fa-light ${icon}`} /> } 
            <span className={isActive ? "active" : ""}>{ title }</span>
            { 
              !isActive && 
              <span className="separator-right">
                  <i className="fa-thin fa-chevron-right"></i>
              </span>
            } 
        </div>
  )
}

export default Link